<template>
    <div>
        <div class="card border-primary mb-3">
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-12 col-md-4 text-center border-right">
                        <div class="text-center mb-3"><i class="far fa-user fa-4x"></i></div>
                        <h3> {{ model.userName}}</h3>

                    </div>
                    <div class="col-sm-12 col-md-8">
                        <div class="row">
                            <div class="form-group col-sm-12 col-md-6">
                                <label class="font-weight-bold" :for="'username' + _uid">
                                    {{$t('userName')}}
                                </label>
                                <div class="ml-2"
                                     :name="'username' + _uid"
                                     :id="'username' + _uid">
                                    {{model.userName}}
                                </div>
                            </div>

                            <div class="form-group col-sm-12 col-md-6">
                                <label class="font-weight-bold" :for="'email' + _uid">{{ $t('email') }}</label>
                                <div class="ml-2"
                                     :name="'email' + _uid"
                                     :id="'email' + _uid">
                                    {{model.email}}
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-group col-12">
                                <label class="font-weight-bold" :for="'userRoles' + _uid">
                                    {{$t('administration.userRoles.title')}}
                                </label>
                                <div class="ml-2"
                                     :name="'userRoles' + _uid"
                                     :id="'userRoles' + _uid">
                                    <span
                                        v-for="(role, index) in model.roles"
                                        :key="index"
                                        class="badge badge-light m-1 p-2">
                                        {{role}}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="btn-group" role="group" aria-label="User edit button" v-if="allowEdit">
                            <button type="button" class="btn btn-success" @click.stop="showUserEditModal"><i class="fas fa-edit mr-2"></i>{{ $t('buttons.edit.btnText')}}</button>
                        </div>

                    </div>
                </div>
            </div>
            <div class="card-footer text-muted" v-if="model.lastLogTime">
                <span class="m-1">
                    {{ $t('administration.user.lastLogTime') +  moment(model.lastLogTime).format('DD.MM.YYYY HH:mm:ss')  }}
                </span>
                <span class="m-1">
                    <span v-if="model.updatedBy">{{ ' / ' + $t('lastUpdatedBy') }} <strong>{{ model.updatedBy }}</strong></span>
                    <span v-if="model.updatedAt">{{ ' - ' + moment(model.updatedAt).format('DD.MM.YYYY HH:mm:ss') }}</span>
                </span>
            </div>
        </div>

        <UserEditModal v-model="model" :show="showUserEdit" @onClose="onUserEditClose" @onSave="onUserEdit"></UserEditModal>

    </div>
</template>

<script>
    import { AspNetUser } from '@/models/models';
    import { Culture } from '@/models/enums';
    import UserEditModal from '@/components/user/edit.modal'
    import moment from 'moment';

    export default {
        props: {
            value: {
                type: AspNetUser,
                required: false
            },
            allowEdit: {
                type: Boolean,
                required: false
            }
        },
        components: {
            UserEditModal
        },
        data() {
            return {
                model: this.value,
                moment: moment,
                showUserEdit: false
            }
        },
        mounted() {

        },
        methods: {
            showUserEditModal() {
                this.showUserEdit = true;
            },
            onUserEditClose() {
                this.showUserEdit = false;
            },
            onUserEdit() {
                this.$emit("userEdit");
                this.showUserEdit = false;
            },
        },
        computed: {
            isEnVersion() {
                return this.$store.getters.currentCulture === Culture.EN;
            },
        },
        watch: {
            value: function (val) {
                if (val) {
                    this.model = new AspNetUser(this.value);
                }
            }
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
